import { useMemo } from 'react';
import { useObjectScope } from '@/shared/object-scope';

export interface ConfigurationApartment {
  id: string;
  name: string;
}

/** Apartments der aktuellen Objektwahl mit ihrem Arbeitsnamen (interner Name vor Name). */
export function useConfigurationApartments(): ConfigurationApartment[] {
  const { groups, groupId } = useObjectScope();
  return useMemo(
    () =>
      (groupId ? groups.filter((group) => group.id === groupId) : groups).flatMap((group) =>
        group.apartments.map((apartment) => ({
          id: apartment.id,
          name: apartment.adminDisplayName || apartment.name,
        })),
      ),
    [groupId, groups],
  );
}
